import React from "react";

const SearchField = ({
    placeholder,
    onChange,
    className,
}) => {

    return (
        <div className={`${className} max-h-12 mb-10`}>
            <label
                htmlFor="default-search"
                className="mb-2 text-sm font-medium text-gray-900 sr-only"
            >
                بحث ..
            </label>
            <div className="relative">
                <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
                    <svg
                        className="w-4 h-4 text-gray-500"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 20 20"
                    >
                        <path
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                        />
                    </svg>
                </div>
                <input
                    type="search"
                    id="default-search"
                    className="block w-full lg:max-w-md p-2 ps-10 text-base text-gray-900 border border-gray-300
                     rounded-lg bg-gray-50  focus:ring-primary"
                    placeholder={placeholder ? placeholder : "بحث ..."}
                    onChange={onChange}
                />
            </div>
        </div>
    );
};

export default SearchField;
